.page {
  height: 100%;
  background-color: #f7f7f7;
  overflow: auto;

  .build {
    margin: 20px;
    padding: 25px;
    box-shadow: 0 0 30px #00000020;
    border-radius: 20px;

    h3 {
      margin: 0;
      margin-bottom: 15px;
      margin-top: 40px;

      &:first-child {
        margin-top: 0;
      }
    }

    img {
      cursor: pointer;
      transition: transform 200ms;

      &:hover {
        transform: scale(1.05);
      }

      &:active {
        transform: scale(1);
      }
    }
  }

  .show {
    padding: 25px;
  }

  .border {
    border: 1px solid #000000;
    width: 502px;
    height: 502px;
  }

  .output {
    width: 500px;
    height: 500px;
    position: relative;
    background-color: #ffffff;

    img {
      touch-action: none;
      position: absolute;
      z-index: 1;
    }
  }

  .mint {
    padding: 0 50px;
    height: 50px;
    display: flex;
    align-items: center;
    background-color: #1854d5;
    color: #ffffff;
    font-weight: bold;
    border-radius: 15px;

    &.minting {
      pointer-events: none;
      opacity: 0.7;
    }
  }

  .addRoyalty {
    input {
      width: 170px;
      padding: 15px 20px;
      background-color: #ffffff;
      border-radius: 15px;
      font-size: 16px;
      margin-right: 10px;
    }

    button {
      cursor: pointer;
      padding: 15px 20px;
      background-color: #ffffff;
      border-radius: 15px;
      font-size: 16px;
    }
  }
}
